// import { useCallback } from 'react'

// import { IGood } from '@monorepo/interfaces'
import { useApi } from '../useApi'

export function useSuggestionRating() {
  const { updateRating } = useApi()

  // const updateHandler = useCallback(
  //   (good: IGood) => {
  //     updateRating(good)
  //   },
  //   [updateRating]
  // )

  return { updateHandler: updateRating }
}
